module.exports = __webpack_public_path__ + "static/media/Services.3304c85f.svg";